import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CurriculumPersistenceService } from '../../services/curriculum-persistence.service';
import { TrainingItemGroupSearchResult } from '../../../training-item-group-search/models/training-item-group-search-result';
import { CurriculumConstants } from '../../constants/curriculum.contants';
import { cloneDeep } from 'lodash-es';
import { MenuItem, MessageService, TreeNode } from 'primeng/api';
import { CurriculumService } from '../../services/curriculum.service';
import { Curriculum } from '../../models/curriculum';
import { TrainingItemGroupSearchComponent } from '../../../training-item-group-search/training-item-group-search/training-item-group-search.component';
import { TrainingItemGroupService } from '../../../training-item/services/training-item-group.service';
import { TrainingItemGroupDetails } from '../../../training-item/models/training-item-group-detail';

@Component({
  selector: 'app-curriculum-training-item-group-details',
  templateUrl: './curriculum-training-item-group-details.component.html',
  styleUrls: ['./curriculum-training-item-group-details.component.scss']
})
export class CurriculumTrainingItemGroupDetailsComponent implements OnInit {
  feature:string = CurriculumConstants.Curriculum_Feature;
  constructor(private curriculumPersistenceService: CurriculumPersistenceService,
    private curriculumService: CurriculumService, private messageService: MessageService,
    private trainingItemGroupService: TrainingItemGroupService) {
    this.items = [
      {
        label: 'Add',
        command: this.add
      }
    ]
  }

  ngOnInit(): void {
    this.curriculumPersistenceService.curriculumSaveInProgress$.
      subscribe((curriculumSaveStatus) => {
        this.isCurriculumSaveInProgress = curriculumSaveStatus;
      });
    this.curriculumPersistenceService.closeAndResetCurriculumSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetCurriculumSlider(); }
    })
  }

  isCurriculumSaveInProgress: boolean = false;
  selectedTrainingItemGroups: TrainingItemGroupSearchResult[] = [];
  displayDataCollected: string[] = [];
  trainingItemGroupSearchResult: TrainingItemGroupSearchResult[] = [];
  trainingItemGroupDetails: TrainingItemGroupDetails[] = [];
  showAddButton: boolean = false;
  curriculumSaveProgressMessage: string = CurriculumConstants.Curriculum_SaveInProgress;
  addAndClose: boolean = false;
  eQMSScopes: number[] = [];
  trainingItemNumbers: string[] = [];
  validTrainingItemGroups: string[] = [];
  items: MenuItem[] = [];
  errorCount: number = 0;
  scope?: number;
  curriculum !: Curriculum;
  isUpdate: boolean = false;
  @Input() selectedScope!: TreeNode;
  @ViewChild(TrainingItemGroupSearchComponent)
  private trainingGroupItemSearch!: TrainingItemGroupSearchComponent;

  add = () => {
    this.addAndClose = false;
    this.getLinkedItems(this.addAndClose);
  };

  closeAndResetCurriculumSlider() {
    this.selectedTrainingItemGroups = [];
    this.displayDataCollected = [];
    this.trainingItemGroupSearchResult = [];
    this.showAddButton = false;
  }

  onSelectionOrDeselection = (trainingItemGroups: TrainingItemGroupSearchResult[]) => {
    let selectedTrainingItemGroupsList: string[] = [];
    trainingItemGroups.forEach(element => {
      selectedTrainingItemGroupsList.push(element.number);
    });
    this.displayDataCollected = []
    this.displayDataCollected = selectedTrainingItemGroupsList;
    this.selectedTrainingItemGroups = [];
    this.selectedTrainingItemGroups = cloneDeep(trainingItemGroups);
  }

  showOrHideAddButton = (displayAddBtn: boolean) => {
    this.showAddButton = displayAddBtn;
  }
  addCurriculumAndClose() {
    this.addAndClose = true;
    this.getLinkedItems(this.addAndClose);
  }

  getLinkedItems(addAndClose: boolean) {
    this.eQMSScopes = [];
    this.displayDataCollected = Object.assign([], this.displayDataCollected);
    this.errorCount = 0;
    this.scope = this.selectedScope.data.eQMSScopeId
    //Get curriculum
    this.curriculumService.getCurriculum(this.scope).subscribe((curriculum) => {
      this.curriculum = curriculum;
      this.curriculumPersistenceService.updateCurriculumDetails(curriculum);
      if (this.curriculum != null) {
        this.isUpdate = true;
      }
      //Get training items of the selected training item groups
      this.trainingItemGroupService.getTrainingItems(this.displayDataCollected).subscribe((trainingGroupItemsDetails: any[]) => {
        this.trainingItemGroupDetails = trainingGroupItemsDetails;
        this.validateAndCreateOrUpdateCurriculum(addAndClose);
        this.trainingGroupItemSearch.getLinkedItemsSelection();
      });
    });
  }

  validateAndCreateOrUpdateCurriculum(addAndClose: boolean) {
    if (this.displayDataCollected.length <= 0) {
      this.validateToSelectAtleastOneTrainingItem();
    }else {
      this.getParentScopesAndCompare(addAndClose);
    }
  }

  getParentScopesAndCompare(addAndClose: boolean) {
    const scopes: any[] = [];
    scopes.push(this.selectedScope.data.eQMSScopeId);
    this.selectedScope.data?.ancestors.forEach((ele: number) => {
      scopes.push(ele);
    });
    const matchingtrainingItemGroups: any[] = [];
    const mismatchedtrainingItemGroups: any[] = [];

    this.displayDataCollected.forEach((data) => {
      var trainingItemGroupDetail = this.trainingItemGroupDetails.filter((tig) => { return tig.number === data });
      const { eQMSScopes } = trainingItemGroupDetail[0];
      const hasMatch = eQMSScopes.some((scope: number) => scopes.includes(scope));
      if (hasMatch) {
        matchingtrainingItemGroups.push(data);
      } else {
        mismatchedtrainingItemGroups.push(data);
      }
    });
    if (mismatchedtrainingItemGroups.length) {
      this.displayScopeValidationMessage(mismatchedtrainingItemGroups);
    }
    if (matchingtrainingItemGroups.length) {
      this.selectedItems(matchingtrainingItemGroups);
      if (!this.isUpdate) {
        this.addCurriculum(matchingtrainingItemGroups, addAndClose);
      }
      else {
        this.updateCurriculum(matchingtrainingItemGroups, addAndClose);
      }
    }
  }

  addCurriculum(matchingtrainingItemGroups: any[], addAndClose: boolean) {
    let matchingTrainingItemGroupsDetails = this.trainingItemsOfValidTrainingItemGroups(matchingtrainingItemGroups);
    this.curriculumPersistenceService.prepareDataForTrainingItemGroupTrainingItem(matchingTrainingItemGroupsDetails, this.isUpdate, this.scope);
    this.curriculumPersistenceService.addCurriculum(addAndClose);
  }

  updateCurriculum(matchingtrainingItemGroups: any[], addAndClose: boolean) {
    let matchingTrainingItemGroupsDetails = this.trainingItemsOfValidTrainingItemGroups(matchingtrainingItemGroups);
    this.curriculumPersistenceService.prepareDataForTrainingItemGroupTrainingItem(matchingTrainingItemGroupsDetails,
      this.isUpdate, this.scope);
    if (this.curriculumPersistenceService.duplicateTrainingItemsNumber.length > 0) {
      //show warning message
      const trainingItemCode = this.curriculumPersistenceService.duplicateTrainingItemsNumber.map((item) => `${item}`).join(",");
      const validationMessage = CurriculumConstants.Curriculum_Warning_TrainingItemAlreadyPresentMessage.replace(
        'TrainingItems',
        `\n${trainingItemCode}`
      );
      this.messageService.add({
        severity: CurriculumConstants.Severity_Warning,
        summary: `${validationMessage}`,
        sticky: true
      });
    }
    if (this.curriculumPersistenceService.duplicateTrainingItemNumbersWithRemoveStatus.length > 0) {
      const trainingItemCode = this.curriculumPersistenceService.duplicateTrainingItemNumbersWithRemoveStatus.map((item) => `${item}`).join(",");
      const validationMessage = CurriculumConstants.Curriculum_Warning_TrainingItemMovedToActiveMessage.replace(
        'TrainingItems',
        `\n${trainingItemCode}`
      );
      this.messageService.add({
        severity: CurriculumConstants.Severity_Warning,
        summary: `${validationMessage}`,
        sticky: true
      });
    }

    this.curriculumPersistenceService.updateCurriculum(addAndClose);
  }

  selectedItems(serviceData: any[]) {
    if (!this.validTrainingItemGroups || this.validTrainingItemGroups.length === 0) {
      this.validTrainingItemGroups = serviceData;
    } else {
      this.validTrainingItemGroups.push(...serviceData);
    }
  }

  displayScopeValidationMessage(mismatchedtrainingItemGroups: any[]) {
    this.errorCount = 0;
    const trainingItemGroupNumbersString = mismatchedtrainingItemGroups.map((trainingItemGroup) => `  ${trainingItemGroup}`).join(', ');
    const validationMessage = CurriculumConstants.Selected_TrainingItemGroupscopes_Not_Matching_Error_Message.replace(
      'TrainingItemGroupNumbers',
      `\n${trainingItemGroupNumbersString}`
    );
    this.messageService.add({
      severity: CurriculumConstants.Severity_Err,
      summary: `${validationMessage}`,
      sticky: true
    });
    this.errorCount++;
  }

  validateToSelectAtleastOneTrainingItem() {
    this.errorCount = 0;
    this.messageService.add({
      severity: CurriculumConstants.Severity_Err,
      summary: `${CurriculumConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
      sticky: true
    });
    this.errorCount++;
  }

  trainingItemsOfValidTrainingItemGroups(trainingItemGroupNumbers: string[]): TrainingItemGroupDetails[] {
    let trainingItemGroups: TrainingItemGroupDetails[] = [];
    trainingItemGroupNumbers.forEach((tig) => {
      trainingItemGroups.push(this.trainingItemGroupDetails.filter((tigDeatils) => {
        return tigDeatils.number === tig;
      })[0]
      );
    });
    return trainingItemGroups;
  }
}
